<template>
  <!-- :clickToClose="false" -->
  <modal
    name="customWorks"
    @before-open="beforeOpen"
    @opened="opened"
    @before-close="beforeClose"
    @closed="kill"
    :clickToClose="true"
    :width="660" :height="'auto'" :scrollable="true" :classes="[]"
    transition="nice-modal-fade"
  >
    <div class="container-wrapper" @click="hide" @keydown.stop>
      <div class="container" @click.stop>
        <div class="close-btn" @click="hide()"></div>
        <div class="header">我要定制</div>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
          <el-form-item label="姓名" prop="name" class="dialog-input input-sort">
            <el-input v-model="form.name" placeholder="您的姓名" maxlength="8"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone" class="dialog-input input-sort">
            <el-input v-model="form.phone" placeholder="我们将通过手机与您进行沟通" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="图形验证码" prop="captcha" class="dialog-input input-sort">
            <el-input v-model="form.captcha" placeholder="请输入图形验证码"></el-input>
            <img class="input-captcha" :src="captchaUrl" @click="refreshCaptcha" />
          </el-form-item>
          <el-form-item label="验证码" prop="code" class="dialog-input input-sort">
            <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
            <el-button ref="regBtn" type="primary" :disabled="regBtn.disabled" @click="reSendVerifyCode">{{ regBtn.text }}</el-button>
          </el-form-item>
          <!-- 微信号 start-->
          <el-form-item label="微信号" class="dialog-input input-sort">
            <el-input v-model="form.wx" placeholder="主要用于在线沟通"></el-input>
            <div class="errorMsg"></div>
          </el-form-item>
          <!-- 微信号 end -->
          <el-form-item label="定制类型" prop="domain">
            <el-checkbox-group v-model="form.domain">
              <el-checkbox v-for="(item,index) in domainList" :key="index" :label="item" name="domain">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="价格预算" prop="money" class="dialog-input input-sort-short">
            <!-- <el-input-number v-model="form.money" :max="maxNumber"></el-input-number>&nbsp;&nbsp;&nbsp;元 -->
            <el-input v-model="form.money" maxlength="8" @input="handleInput"></el-input>&nbsp;&nbsp;&nbsp;元
          </el-form-item>
          <el-form-item label="需求描述" prop="description" class="dialog-input">
            <el-input v-model="form.description" type="textarea" :autosize="{minRows: 5, maxRows: 8}" rows="5" maxlength="150" resize="none" placeholder="简单描述您的需求，如：视频用途、风格偏好、企业文化、公司logo"></el-input>
            <div class="textarea-maxlength">{{ form.description.length }}/150字</div>
          </el-form-item>

          <!-- 样例效果 start -->
          <el-form-item label="样例效果" prop="description" class="dialog-input">
            <span style="color: #aca8c4;">您还可以通过样例或者文档的形式，来描述您的需求</span>
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content">
                最多可添加5个附件，每个大小不超过50M；
                <br />仅支持jpg、jpeg、png及pdf格式
              </div>
              <i class="el-icon-question" style="color: #aca8c4;"></i>
            </el-tooltip>
          </el-form-item>
          <!-- 样例效果 end -->

          <!-- 上传 start -->
          <el-form-item v-if="aliveUpload" label class="dialog-input uploads-box">
            <el-upload v-if="aliveUpload" ref="upload" action="/api/upload/file" list-type="picture-card" :show-file-list="true" :on-success="onSuccess" :on-progress="onProgress" :on-error="onError" :on-exceed="onExceed" :before-upload="beforeUpload" :file-list="fileList" :limit="5">
              <el-progress v-if="isProgress" type="circle" :stroke-width="4" :percentage="percentage" :width="100"></el-progress>
              <!-- <img :src="imageView(files)" alt="" v-else> -->
              <div class="upload-text">
                <!-- <i class="el-icon-upload upload-icon"></i> -->
                <i class="upload-icon"></i>
                <span class="file-btn-text">上传附件</span>
              </div>
            </el-upload>
          </el-form-item>
          <!-- 上传 end -->
        </el-form>
        <div class="dialog-footer" style="display: flex; justify-content: center;">
          <el-button type="primary" @click="submit('form')">提交</el-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    // ...mapGetters(["domainList"])
    ...mapGetters({
      storedUserId: 'getUserId',
    })
  },
  data() {
    //手机号格式校验
    var phoneReg = (rule, value, callback) => {
      const reg = /^(0|86|17951)?((13[0-9])|(14[579])|(15([0-3]|[5-9]))|(16[6])|(17[0135678])|(18[0-9])|(19[89]))\d{8}$/;
      if (!reg.test(value) && value != "") {
        callback(new Error("电话号码格式不正确"));
      }
      callback();
    };
    //验证码校验
    var codeCheck = async (rule, value, callback) => {
      if (this.submiting) {
        let msg = await this.checkVerifyCode(this.form.phone, this.form.code);
        if (msg != "true") {
          callback(new Error(msg));
        }
      }
      callback();
    };
    //价格检验
    var moneyReg = (rule, value, callback) => {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(value)) {
        // callback(new Error("价格格式不正确"));
      }
      callback();
    };
    let visibleForm = this.value;
    return {
      aliveUpload: true,
      maxNumber: 99999999,
      visibleForm, //显示当前弹窗
      form: {
        username: "",
        phone: "",
        captcha: "",
        code: "",
        addressF: "",
        addressC: "",
        domain: [],
        description: "",
        homepage: "",
        works: "",
        imgUrl: "",
        wx: "" // 微信
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写您的姓名",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请填写您的常用手机",
            trigger: "blur"
          },
          { validator: phoneReg, trigger: "blur" }
        ],
        captcha: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          },
          { validator: codeCheck }
        ],
        domain: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个定制类型",
            trigger: "change"
          }
        ]
      },
      isCheckeCaptcha: false,
      isSendCode: false,
      regBtn: {
        disabled: false,
        text: "发送验证码"
      },
      percentage: 0, //上传进度
      files: "", // 上传的附件
      fileList: [], // 上传的文件列表
      dialogVisible: false, // 是否显示弹框
      isProgress: false, // 是否显示进度条
      countdown: 60,
      captchaUrl: "", // 图形验证码
      stop_msg: false,
      submiting: false, //提交中
      domainList:[
        { sort: 1, label: "创意模板" },
        { sort: 2, label: "专属视频" },
        { sort: 3, label: "定制背景" },
        { sort: 4, label: "艺术文字" },
        { sort: 5, label: "定制角色" },
        { sort: 6, label: "定制道具" },
        { sort: 7, label: "定制形状" },
        { sort: 8, label: "其他" }
      ], //创作类型列表
    };
  },
  watch: {
    value(val) {
      this.visibleForm = val;
      if (val) {
        this.refreshCaptcha();
      }
    },
    visibleForm(val) {
      this.$emit("input", val);
    },
    aliveUpload (val) {
      if (!val) {
        this.$refs.upload.$destroy();
      }
    }
  },
  methods: {
    beforeOpen() {
      // this.aliveUpload = true;
      this.refreshCaptcha();
    },
    opened () {
      this.aliveUpload = true;
      this.$nextTick(() => {
        // this.$refs.upload.clearFiles();
        let el = this.$refs.upload.$el;
        $(el).find('.el-upload-list__item').remove();
      });
    },
    beforeClose () {
      this.beforeCloseDialog();
    },
    hide() {
      this.$modal.hide('customWorks');
    },
    kill () {
      // this.$bus.emit('killCustomWorks');
    },
    //更新图形验证码
    refreshCaptcha() {
      this.form.captcha = "";
      var times = Date.parse(new Date());
      this.captchaUrl = "/api/verify/imgCaptcha/new" + "?num=" + times;
    },
    reSendVerifyCode() {
      let flag = true;
      this.$refs["form"].validateField("phone", res => {
        flag = res ? false : true;
      });
      this.$refs["form"].validateField("captcha", res => {
        flag = res ? false : true;
      });
      if (!flag) {
        return;
      }
      if (!this.isSendCode) {
        this.sendVerifyCode();
        this.regBtn.disabled = true;
      } else {
        this.refreshCaptcha();
        this.form.code = "";
        this.form.captcha = "";
        this.isSendCode = false;
        this.$message("请重新输入图形验证码");
      }
    },
    //发送验证码
    sendVerifyCode() {
      this.$http
        .get("/api/verify/new", {
          params: {
            phone: this.form.phone,
            email: "",
            captcha: this.form.captcha
          }
        })
        .then(response => {
          var _data = response.data;
          if (_data.code == 200) {
            this.setTime();
            this.isSendCode = true;
          } else {
            this.$message.error(_data.msg);
            this.regBtn.disabled = false;
          }
        })
        .catch(response => {
          //失败
          this.regBtn.disabled = false;
        });
    },
    //验证码计时
    setTime() {
      if (this.countdown == 0) {
        this.stop_msg = false;
        this.regBtn.disabled = false;
        this.regBtn.text = "重新获取验证码";
        this.countdown = 60;
        return false;
      } else {
        this.stop_msg = true;
        this.regBtn.disabled = true;
        this.countdown--;
        this.regBtn.text = "重新发送(" + this.countdown + ")";
      }
      setTimeout(() => {
        this.setTime();
      }, 1000);
    },
    //校验验证码
    checkVerifyCode(phone, code) {
      return new Promise((resolve, reject) => {
        this.$http
          .put("/api/verify", {
            phone: phone,
            email: "",
            code: code
          })
          .then(response => {
            var _data = response.data;
            if (_data.code == 200) {
              resolve("true");
            } else {
              resolve(_data.msg);
            }
          })
          .catch(response => {
            //失败
            reject();
          });
      });
    },
    handleInput(e) {
      this.form.money = e.replace(/[^0-9]/gi, "");
    },
    //处理domain重新排序
    getDomain() {
      function compare(p) {
        return function(m, n) {
          const a = m[p];
          const b = n[p];
          return a - b;
        };
      }
      this.form.domain.sort(compare("sort"));
      let list = [];
      this.form.domain.forEach(item => {
        list.push(item.label);
      });
      return list;
    },
    /**
     * 上传进度
     * @param event 事件
     * @param file 文件对象
     */
    onProgress(event, file) {
      this.percentage = parseInt(file.percentage, 10);
    },
    /**
     * 上传成功后的处理
     * @param res
     */
    async onSuccess(res, file, fileList) {
      this.percentage = 100;
      if (res.code == 200) {
        this.isProgress = false;
        this.files = res.data.filename;
        this.fileList = Object.assign([], fileList);
      }
    },
    /**
     * 上传失败处理
     */
    onError() {
      this.isProgress = false;
      this.$message.error("上传失败，请检查网络是否连接正常!");
    },
    /**
     * 上传之前处理
     * @param file 需要上传的文件对象
     */
    beforeUpload(file) {
      let imgTypes = [
        "image/jpeg",
        "image/jpg",
        "application/pdf",
        "image/png"
      ];
      let isLimit = file.size / 1024 / 1024 < 50; // 上传的附件不能超过50M
      // ...其他限制条件
      if (!isLimit) {
        this.$message.error("上传的附件大小不能超过50M");
        return false;
      }
      if (imgTypes.indexOf(file.type) === -1) {
        this.$message.error("仅支持jpg、jpeg、png及pdf格式");
        return false;
      }
      return true;
    },
    /**
     * 文件超出个数限制时的钩子
     */
    onExceed(files, fileList){
      this.$message.error("最多可添加5个附件");
    },
    /**
     * 上传附件格式化处理
     */
    getFilesList() {
      let _fileList = this.fileList;
      let fileList = [];
      for (let _file of _fileList) {
        let result = _file.response;
        if (result.code === 200) {
          fileList.push(result.data.filename);
        }
      }
      return fileList.join(",");
    },
    /**
     * 预览图片
     * @param file 文件对象
     */
    // onPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    submit(formName) {
      const domain = this.getDomain();
      this.submiting = true;
      this.$refs[formName].validate(async valid => {
        this.submiting = false;
        if (valid) {
          this.$http
            .post("/api/shop/studio/custom", {
              userId: this.storedUserId,
              name: this.form.name,
              phone: this.form.phone,
              domain: domain.join("|"),
              description: this.form.description,
              money: this.form.money,
              contact: this.form.wx,
              accessories: this.getFilesList(),
              code: this.form.code
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: "消息提交成功",
                  type: "success"
                });
                this.visibleForm = false;
                this.hide();
                this.$modal.show('customWorksSubmitted');
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      });
    },
    beforeCloseDialog() {
      this.$refs.form.resetFields();
      this.$refs.upload.clearFiles();
      this.$set(this.$refs.upload, 'uploadFiles', []);
      this.aliveUpload = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.container-wrapper {
  padding-top: 100px;
  padding-bottom: 100px;
}
.container {
  position: relative;
  width: 660px;
  min-height: 1082px;
  background-color: #ffffff;
  box-shadow: 0px 0px 27px 0px rgba(0, 0, 0, 0.11);
  border-radius: 4px;
}
.header {
	font-size: 16px;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #474261;
  text-align: center;
  padding-top: 46px;
}
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  background-image: url(../../../static/svg/cross.svg)
}
</style>

<style lang="scss">
.container {
  text-align: left;
  border-radius: 4px;
  .el-dialog__header {
    padding: 0;
    height: 40px;
    line-height: 40px;
    color: #474261;
    background-color: #f6f6fc;
    border-radius: 4px 4px 0px 0px;
    text-align: center;
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      top: 13px;
      right: 13px;
      .el-dialog__close {
        color: #737596;
        font-weight: bold;
      }
    }
  }
  .el-form {
    padding-top: 30px;
    padding-right: 100px;
  }
  .el-form-item__label {
    padding-right: 30px;
  }
  .is-required .el-form-item__label {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      top: 10px;
      right: 20px;
      width: 4px;
      height: 4px;
      background-color: #ff133a;
      border-radius: 50%;
    }
  }
  .is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "" !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label,
  .el-button--text {
    color: #5778fb;
    width: 72px !important;
  }
  .el-checkbox__label {
    width: 72px !important;
    &:nth-child(4n) {
      margin-left: 0px;
    }
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5778fb;
    border-color: #5778fb;
  }
  .el-checkbox__inner:hover {
    border-color: #5778fb;
  }
  .el-button.el-button--primary {
    margin-left: 15px;
    background-color: #5778fb;
    border-color: #5778fb;
  }
  .el-button--primary.is-disabled,
  .el-button--primary.is-disabled:active,
  .el-button--primary.is-disabled:focus,
  .el-button--primary.is-disabled:hover {
    background-color: #e9e9f3;
    border-color: #e9e9f3;
    color: #999;
  }
  .el-textarea {
    position: relative;
    textarea {
      font-family: "\5FAE\8F6F\96C5\9ED1", Helvetica, Tahoma, Arial,
        "Microsoft Yahei", "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei",
        sans-serif;
    }
    + .textarea-maxlength {
      position: absolute;
      bottom: 0;
      left: 510px;
      width: 80px;
      color: #ccc;
      text-align: right;
    }
  }
  .el-checkbox-group {
    width: 400px + 10px;
    .el-checkbox {
      margin-left: 0;
      margin-right: 50px;
      margin-left: 0;
      &:nth-child(4n + 1) {
        margin-left: 0;
      }
    }
  }
  .el-upload--picture-card {
    width: 112px;
    height: 80px;
    background-color: #f6f6fb;
    border-radius: 8px;
    border: solid 1px #d9ddea;
    margin-right: 32px;
    line-height: 30px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 112px;
    height: 80px;
    background-color: #f6f6fb;
    border-radius: 8px;
    border: solid 1px #d9ddea;
    margin-right: 37px;
  }
  .el-upload-list--picture-card .el-progress {
    width: 80px;
  }
  .el-progress-circle {
    width: 80px !important;
    height: 80px !important;
  }
  .uploads-box {
    display: inline-block;
    margin-right: -110px;
  }
  .el-upload--picture-card {
    & .upload-icon {
      width: 34px;
      height: 26px;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url(../../../static/svg/upload-custom.svg);
    }

    & .file-btn-text {
      color: #9692A9;
    }

    &:hover {
      & .upload-icon {
        background-image: url(../../../static/svg/upload-custom-active.svg);
      }

      & .file-btn-text {
        color: #C8C5D7;
      }
    }
  }
  .upload-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    > span {
      font-size: 12px;
    }
  }
  .el-form {
    & .el-form-item {
      &:nth-child(1), &:nth-child(2), &:nth-child(5)  {
        & .el-input__inner {
          width: 400px + 10px;
        }
      }
      &:nth-child(3), &:nth-child(4)  {
        & .el-input__inner {
          width: 260px;
        }
      }
    }
  }
  .dialog-input {
    input,
    textarea {
      width: 400px + 10px;
      background-color: #f6f6fc;
      // border: 0;
      border-radius: 4px;
    }
    &.input-sort:nth-child(4), &.input-sort:nth-child(3) {
      & .el-form-item__content {
        display: flex;
      }
    }
    &.input-sort input {
      width: 280px;
    }
    &.input-sort-short input {
      margin-top: -13px;
      width: 150px;
    }
    .el-input {
      display: inline;
    }
    .input-captcha {
      margin-left: 15px;
      margin-bottom: -15px;
      width: 112px;
      height: 40px;
      cursor: pointer;
    }
  }
  .dialog-checked {
    margin-top: 40px;
    text-align: center;
    .el-checkbox {
      margin-right: 10px;
    }
    a {
      color: #5778fb;
    }
  }
  [data-modal=customWorks] .dialog-footer {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding-bottom: 60px;
    text-align: center;
    .el-button {
      width: 200px;
    }
    .footer-text {
      margin-top: 15px;
      margin-bottom: 90px;
      font-size: 14px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/topnav/customWorks.vue